const host = window.location.hostname;

let Url = "";
if (host === "landiqdaily.com") {
  Url = "https://api.landiqdaily.com";
} else if (host === "dev.landiqdaily.com") {
  Url = "https://api-dev.landiqdaily.com";
} else {
  Url = "http://localhost:3000";
}

export { Url };
